export const CURRENCIES_CALL = "CURRENCIES_CALL";

export function callCurrencies() {
  return { type: CURRENCIES_CALL };
}
